export const countries = {
  AD: {
    isoAlpha2CountryCode: 'AD',
    isoAlpha3CountryCode: 'AND',
    name: 'Andorra',
    phoneNumberCountryCode: '376',
  },
  AE: {
    isoAlpha2CountryCode: 'AE',
    isoAlpha3CountryCode: 'ARE',
    name: 'United Arab Emirates',
    phoneNumberCountryCode: '971',
  },
  AF: {
    isoAlpha2CountryCode: 'AF',
    isoAlpha3CountryCode: 'AFG',
    name: 'Afghanistan',
    phoneNumberCountryCode: '93',
  },
  AG: {
    isoAlpha2CountryCode: 'AG',
    isoAlpha3CountryCode: 'ATG',
    name: 'Antigua and Barbuda',
    phoneNumberCountryCode: '1',
  },
  AI: {
    isoAlpha2CountryCode: 'AI',
    isoAlpha3CountryCode: 'AIA',
    name: 'Anguilla',
    phoneNumberCountryCode: '1',
  },
  AL: {
    isoAlpha2CountryCode: 'AL',
    isoAlpha3CountryCode: 'ALB',
    name: 'Albania',
    phoneNumberCountryCode: '355',
  },
  AM: {
    isoAlpha2CountryCode: 'AM',
    isoAlpha3CountryCode: 'ARM',
    name: 'Armenia',
    phoneNumberCountryCode: '374',
  },
  AN: {
    isoAlpha2CountryCode: 'AN',
    isoAlpha3CountryCode: 'ANT',
    name: 'Netherlands Antilles',
    phoneNumberCountryCode: '599',
  },
  AO: {
    isoAlpha2CountryCode: 'AO',
    isoAlpha3CountryCode: 'AGO',
    name: 'Angola',
    phoneNumberCountryCode: '244',
  },
  AQ: {
    isoAlpha2CountryCode: 'AQ',
    isoAlpha3CountryCode: 'ATA',
    name: 'Antarctica',
    phoneNumberCountryCode: '672',
  },
  AR: {
    isoAlpha2CountryCode: 'AR',
    isoAlpha3CountryCode: 'ARG',
    name: 'Argentina',
    phoneNumberCountryCode: '54',
  },
  AS: {
    isoAlpha2CountryCode: 'AS',
    isoAlpha3CountryCode: 'ASM',
    name: 'American Samoa',
    phoneNumberCountryCode: '1',
  },
  AT: {
    isoAlpha2CountryCode: 'AT',
    isoAlpha3CountryCode: 'AUT',
    name: 'Austria',
    phoneNumberCountryCode: '43',
  },
  AU: {
    isoAlpha2CountryCode: 'AU',
    isoAlpha3CountryCode: 'AUS',
    name: 'Australia',
    phoneNumberCountryCode: '61',
  },
  AW: {
    isoAlpha2CountryCode: 'AW',
    isoAlpha3CountryCode: 'ABW',
    name: 'Aruba',
    phoneNumberCountryCode: '297',
  },
  AX: {
    isoAlpha2CountryCode: 'AX',
    isoAlpha3CountryCode: 'ALA',
    name: 'Åland Islands',
    phoneNumberCountryCode: '358',
  },
  AZ: {
    isoAlpha2CountryCode: 'AZ',
    isoAlpha3CountryCode: 'AZE',
    name: 'Azerbaijan',
    phoneNumberCountryCode: '994',
  },
  BA: {
    isoAlpha2CountryCode: 'BA',
    isoAlpha3CountryCode: 'BIH',
    name: 'Bosnia and Herzegovina',
    phoneNumberCountryCode: '387',
  },
  BB: {
    isoAlpha2CountryCode: 'BB',
    isoAlpha3CountryCode: 'BRB',
    name: 'Barbados',
    phoneNumberCountryCode: '1',
  },
  BD: {
    isoAlpha2CountryCode: 'BD',
    isoAlpha3CountryCode: 'BGD',
    name: 'Bangladesh',
    phoneNumberCountryCode: '880',
  },
  BE: {
    isoAlpha2CountryCode: 'BE',
    isoAlpha3CountryCode: 'BEL',
    name: 'Belgium',
    phoneNumberCountryCode: '32',
  },
  BF: {
    isoAlpha2CountryCode: 'BF',
    isoAlpha3CountryCode: 'BFA',
    name: 'Burkina Faso',
    phoneNumberCountryCode: '226',
  },
  BG: {
    isoAlpha2CountryCode: 'BG',
    isoAlpha3CountryCode: 'BGR',
    name: 'Bulgaria',
    phoneNumberCountryCode: '359',
  },
  BH: {
    isoAlpha2CountryCode: 'BH',
    isoAlpha3CountryCode: 'BHR',
    name: 'Bahrain',
    phoneNumberCountryCode: '973',
  },
  BI: {
    isoAlpha2CountryCode: 'BI',
    isoAlpha3CountryCode: 'BDI',
    name: 'Burundi',
    phoneNumberCountryCode: '257',
  },
  BJ: {
    isoAlpha2CountryCode: 'BJ',
    isoAlpha3CountryCode: 'BEN',
    name: 'Benin',
    phoneNumberCountryCode: '229',
  },
  BL: {
    isoAlpha2CountryCode: 'BL',
    isoAlpha3CountryCode: 'BLM',
    name: 'Saint Barthelemy',
    phoneNumberCountryCode: '590',
  },
  BM: {
    isoAlpha2CountryCode: 'BM',
    isoAlpha3CountryCode: 'BMU',
    name: 'Bermuda',
    phoneNumberCountryCode: '1',
  },
  BN: {
    isoAlpha2CountryCode: 'BN',
    isoAlpha3CountryCode: 'BRN',
    name: 'Brunei',
    phoneNumberCountryCode: '673',
  },
  BO: {
    isoAlpha2CountryCode: 'BO',
    isoAlpha3CountryCode: 'BOL',
    name: 'Bolivia',
    phoneNumberCountryCode: '591',
  },
  BQ: {
    isoAlpha2CountryCode: 'BQ',
    isoAlpha3CountryCode: 'BES',
    name: 'Bonaire, Sint Eustatius and Saba',
    phoneNumberCountryCode: '599',
  },
  BR: {
    isoAlpha2CountryCode: 'BR',
    isoAlpha3CountryCode: 'BRA',
    name: 'Brazil',
    phoneNumberCountryCode: '55',
  },
  BS: {
    isoAlpha2CountryCode: 'BS',
    isoAlpha3CountryCode: 'BHS',
    name: 'Bahamas',
    phoneNumberCountryCode: '1',
  },
  BT: {
    isoAlpha2CountryCode: 'BT',
    isoAlpha3CountryCode: 'BTN',
    name: 'Bhutan',
    phoneNumberCountryCode: '975',
  },
  BV: {
    isoAlpha2CountryCode: 'BV',
    isoAlpha3CountryCode: 'BVT',
    name: 'Bouvet Island',
    phoneNumberCountryCode: '47',
  },
  BW: {
    isoAlpha2CountryCode: 'BW',
    isoAlpha3CountryCode: 'BWA',
    name: 'Botswana',
    phoneNumberCountryCode: '267',
  },
  BY: {
    isoAlpha2CountryCode: 'BY',
    isoAlpha3CountryCode: 'BLR',
    name: 'Belarus',
    phoneNumberCountryCode: '375',
  },
  BZ: {
    isoAlpha2CountryCode: 'BZ',
    isoAlpha3CountryCode: 'BLZ',
    name: 'Belize',
    phoneNumberCountryCode: '501',
  },
  CA: {
    isoAlpha2CountryCode: 'CA',
    isoAlpha3CountryCode: 'CAN',
    name: 'Canada',
    phoneNumberCountryCode: '1',
  },
  CC: {
    isoAlpha2CountryCode: 'CC',
    isoAlpha3CountryCode: 'CCK',
    name: 'Cocos Islands',
    phoneNumberCountryCode: '61',
  },
  CD: {
    isoAlpha2CountryCode: 'CD',
    isoAlpha3CountryCode: 'COD',
    name: 'Democratic Republic of the Congo',
    phoneNumberCountryCode: '243',
  },
  CF: {
    isoAlpha2CountryCode: 'CF',
    isoAlpha3CountryCode: 'CAF',
    name: 'Central African Republic',
    phoneNumberCountryCode: '236',
  },
  CG: {
    isoAlpha2CountryCode: 'CG',
    isoAlpha3CountryCode: 'COG',
    name: 'Republic of the Congo',
    phoneNumberCountryCode: '242',
  },
  CH: {
    isoAlpha2CountryCode: 'CH',
    isoAlpha3CountryCode: 'CHE',
    name: 'Switzerland',
    phoneNumberCountryCode: '41',
  },
  CI: {
    isoAlpha2CountryCode: 'CI',
    isoAlpha3CountryCode: 'CIV',
    name: 'Ivory Coast',
    phoneNumberCountryCode: '225',
  },
  CK: {
    isoAlpha2CountryCode: 'CK',
    isoAlpha3CountryCode: 'COK',
    name: 'Cook Islands',
    phoneNumberCountryCode: '682',
  },
  CL: {
    isoAlpha2CountryCode: 'CL',
    isoAlpha3CountryCode: 'CHL',
    name: 'Chile',
    phoneNumberCountryCode: '56',
  },
  CM: {
    isoAlpha2CountryCode: 'CM',
    isoAlpha3CountryCode: 'CMR',
    name: 'Cameroon',
    phoneNumberCountryCode: '237',
  },
  CN: {
    isoAlpha2CountryCode: 'CN',
    isoAlpha3CountryCode: 'CHN',
    name: 'China',
    phoneNumberCountryCode: '86',
  },
  CO: {
    isoAlpha2CountryCode: 'CO',
    isoAlpha3CountryCode: 'COL',
    name: 'Colombia',
    phoneNumberCountryCode: '57',
  },
  CR: {
    isoAlpha2CountryCode: 'CR',
    isoAlpha3CountryCode: 'CRI',
    name: 'Costa Rica',
    phoneNumberCountryCode: '506',
  },
  CU: {
    isoAlpha2CountryCode: 'CU',
    isoAlpha3CountryCode: 'CUB',
    name: 'Cuba',
    phoneNumberCountryCode: '53',
  },
  CV: {
    isoAlpha2CountryCode: 'CV',
    isoAlpha3CountryCode: 'CPV',
    name: 'Cape Verde',
    phoneNumberCountryCode: '238',
  },
  CW: {
    isoAlpha2CountryCode: 'CW',
    isoAlpha3CountryCode: 'CUW',
    name: 'Curacao',
    phoneNumberCountryCode: '599',
  },
  CX: {
    isoAlpha2CountryCode: 'CX',
    isoAlpha3CountryCode: 'CXR',
    name: 'Christmas Island',
    phoneNumberCountryCode: '61',
  },
  CY: {
    isoAlpha2CountryCode: 'CY',
    isoAlpha3CountryCode: 'CYP',
    name: 'Cyprus',
    phoneNumberCountryCode: '357',
  },
  CZ: {
    isoAlpha2CountryCode: 'CZ',
    isoAlpha3CountryCode: 'CZE',
    name: 'Czech Republic',
    phoneNumberCountryCode: '420',
  },
  DE: {
    isoAlpha2CountryCode: 'DE',
    isoAlpha3CountryCode: 'DEU',
    name: 'Germany',
    phoneNumberCountryCode: '49',
  },
  DJ: {
    isoAlpha2CountryCode: 'DJ',
    isoAlpha3CountryCode: 'DJI',
    name: 'Djibouti',
    phoneNumberCountryCode: '253',
  },
  DK: {
    isoAlpha2CountryCode: 'DK',
    isoAlpha3CountryCode: 'DNK',
    name: 'Denmark',
    phoneNumberCountryCode: '45',
  },
  DM: {
    isoAlpha2CountryCode: 'DM',
    isoAlpha3CountryCode: 'DMA',
    name: 'Dominica',
    phoneNumberCountryCode: '1',
  },
  DO: {
    isoAlpha2CountryCode: 'DO',
    isoAlpha3CountryCode: 'DOM',
    name: 'Dominican Republic',
    phoneNumberCountryCode: '1',
  },
  DZ: {
    isoAlpha2CountryCode: 'DZ',
    isoAlpha3CountryCode: 'DZA',
    name: 'Algeria',
    phoneNumberCountryCode: '213',
  },
  EC: {
    isoAlpha2CountryCode: 'EC',
    isoAlpha3CountryCode: 'ECU',
    name: 'Ecuador',
    phoneNumberCountryCode: '593',
  },
  EE: {
    isoAlpha2CountryCode: 'EE',
    isoAlpha3CountryCode: 'EST',
    name: 'Estonia',
    phoneNumberCountryCode: '372',
  },
  EG: {
    isoAlpha2CountryCode: 'EG',
    isoAlpha3CountryCode: 'EGY',
    name: 'Egypt',
    phoneNumberCountryCode: '20',
  },
  EH: {
    isoAlpha2CountryCode: 'EH',
    isoAlpha3CountryCode: 'ESH',
    name: 'Western Sahara',
    phoneNumberCountryCode: '212',
  },
  ER: {
    isoAlpha2CountryCode: 'ER',
    isoAlpha3CountryCode: 'ERI',
    name: 'Eritrea',
    phoneNumberCountryCode: '291',
  },
  ES: {
    isoAlpha2CountryCode: 'ES',
    isoAlpha3CountryCode: 'ESP',
    name: 'Spain',
    phoneNumberCountryCode: '34',
  },
  ET: {
    isoAlpha2CountryCode: 'ET',
    isoAlpha3CountryCode: 'ETH',
    name: 'Ethiopia',
    phoneNumberCountryCode: '251',
  },
  FI: {
    isoAlpha2CountryCode: 'FI',
    isoAlpha3CountryCode: 'FIN',
    name: 'Finland',
    phoneNumberCountryCode: '358',
  },
  FJ: {
    isoAlpha2CountryCode: 'FJ',
    isoAlpha3CountryCode: 'FJI',
    name: 'Fiji',
    phoneNumberCountryCode: '679',
  },
  FK: {
    isoAlpha2CountryCode: 'FK',
    isoAlpha3CountryCode: 'FLK',
    name: 'Falkland Islands',
    phoneNumberCountryCode: '500',
  },
  FM: {
    isoAlpha2CountryCode: 'FM',
    isoAlpha3CountryCode: 'FSM',
    name: 'Micronesia',
    phoneNumberCountryCode: '691',
  },
  FO: {
    isoAlpha2CountryCode: 'FO',
    isoAlpha3CountryCode: 'FRO',
    name: 'Faroe Islands',
    phoneNumberCountryCode: '298',
  },
  FR: {
    isoAlpha2CountryCode: 'FR',
    isoAlpha3CountryCode: 'FRA',
    name: 'France',
    phoneNumberCountryCode: '33',
  },
  GA: {
    isoAlpha2CountryCode: 'GA',
    isoAlpha3CountryCode: 'GAB',
    name: 'Gabon',
    phoneNumberCountryCode: '241',
  },
  GB: {
    isoAlpha2CountryCode: 'GB',
    isoAlpha3CountryCode: 'GBR',
    name: 'United Kingdom',
    phoneNumberCountryCode: '44',
  },
  GD: {
    isoAlpha2CountryCode: 'GD',
    isoAlpha3CountryCode: 'GRD',
    name: 'Grenada',
    phoneNumberCountryCode: '1',
  },
  GE: {
    isoAlpha2CountryCode: 'GE',
    isoAlpha3CountryCode: 'GEO',
    name: 'Georgia',
    phoneNumberCountryCode: '995',
  },
  GF: {
    isoAlpha2CountryCode: 'GF',
    isoAlpha3CountryCode: 'GUF',
    name: 'French Guiana',
    phoneNumberCountryCode: '594',
  },
  GG: {
    isoAlpha2CountryCode: 'GG',
    isoAlpha3CountryCode: 'GGY',
    name: 'Guernsey',
    phoneNumberCountryCode: '44',
  },
  GH: {
    isoAlpha2CountryCode: 'GH',
    isoAlpha3CountryCode: 'GHA',
    name: 'Ghana',
    phoneNumberCountryCode: '233',
  },
  GI: {
    isoAlpha2CountryCode: 'GI',
    isoAlpha3CountryCode: 'GIB',
    name: 'Gibraltar',
    phoneNumberCountryCode: '350',
  },
  GL: {
    isoAlpha2CountryCode: 'GL',
    isoAlpha3CountryCode: 'GRL',
    name: 'Greenland',
    phoneNumberCountryCode: '299',
  },
  GM: {
    isoAlpha2CountryCode: 'GM',
    isoAlpha3CountryCode: 'GMB',
    name: 'Gambia',
    phoneNumberCountryCode: '220',
  },
  GN: {
    isoAlpha2CountryCode: 'GN',
    isoAlpha3CountryCode: 'GIN',
    name: 'Guinea',
    phoneNumberCountryCode: '224',
  },
  GP: {
    isoAlpha2CountryCode: 'GP',
    isoAlpha3CountryCode: 'GLP',
    name: 'Guadeloupe',
    phoneNumberCountryCode: '590',
  },
  GQ: {
    isoAlpha2CountryCode: 'GQ',
    isoAlpha3CountryCode: 'GNQ',
    name: 'Equatorial Guinea',
    phoneNumberCountryCode: '240',
  },
  GR: {
    isoAlpha2CountryCode: 'GR',
    isoAlpha3CountryCode: 'GRC',
    name: 'Greece',
    phoneNumberCountryCode: '30',
  },
  GS: {
    isoAlpha2CountryCode: 'GS',
    isoAlpha3CountryCode: 'SGS',
    name: 'South Georgia and the South Sandwich Islands',
    phoneNumberCountryCode: '500',
  },
  GT: {
    isoAlpha2CountryCode: 'GT',
    isoAlpha3CountryCode: 'GTM',
    name: 'Guatemala',
    phoneNumberCountryCode: '502',
  },
  GU: {
    isoAlpha2CountryCode: 'GU',
    isoAlpha3CountryCode: 'GUM',
    name: 'Guam',
    phoneNumberCountryCode: '1',
  },
  GW: {
    isoAlpha2CountryCode: 'GW',
    isoAlpha3CountryCode: 'GNB',
    name: 'Guinea-Bissau',
    phoneNumberCountryCode: '245',
  },
  GY: {
    isoAlpha2CountryCode: 'GY',
    isoAlpha3CountryCode: 'GUY',
    name: 'Guyana',
    phoneNumberCountryCode: '592',
  },
  HK: {
    isoAlpha2CountryCode: 'HK',
    isoAlpha3CountryCode: 'HKG',
    name: 'Hong Kong',
    phoneNumberCountryCode: '852',
  },
  HM: {
    isoAlpha2CountryCode: 'HM',
    isoAlpha3CountryCode: 'HMD',
    name: 'Heard Island and McDonald Islands',
    phoneNumberCountryCode: '672',
  },
  HN: {
    isoAlpha2CountryCode: 'HN',
    isoAlpha3CountryCode: 'HND',
    name: 'Honduras',
    phoneNumberCountryCode: '504',
  },
  HR: {
    isoAlpha2CountryCode: 'HR',
    isoAlpha3CountryCode: 'HRV',
    name: 'Croatia',
    phoneNumberCountryCode: '385',
  },
  HT: {
    isoAlpha2CountryCode: 'HT',
    isoAlpha3CountryCode: 'HTI',
    name: 'Haiti',
    phoneNumberCountryCode: '509',
  },
  HU: {
    isoAlpha2CountryCode: 'HU',
    isoAlpha3CountryCode: 'HUN',
    name: 'Hungary',
    phoneNumberCountryCode: '36',
  },
  ID: {
    isoAlpha2CountryCode: 'ID',
    isoAlpha3CountryCode: 'IDN',
    name: 'Indonesia',
    phoneNumberCountryCode: '62',
  },
  IE: {
    isoAlpha2CountryCode: 'IE',
    isoAlpha3CountryCode: 'IRL',
    name: 'Ireland',
    phoneNumberCountryCode: '353',
  },
  IL: {
    isoAlpha2CountryCode: 'IL',
    isoAlpha3CountryCode: 'ISR',
    name: 'Israel',
    phoneNumberCountryCode: '972',
  },
  IM: {
    isoAlpha2CountryCode: 'IM',
    isoAlpha3CountryCode: 'IMN',
    name: 'Isle of Man',
    phoneNumberCountryCode: '44',
  },
  IN: {
    isoAlpha2CountryCode: 'IN',
    isoAlpha3CountryCode: 'IND',
    name: 'India',
    phoneNumberCountryCode: '91',
  },
  IO: {
    isoAlpha2CountryCode: 'IO',
    isoAlpha3CountryCode: 'IOT',
    name: 'British Indian Ocean Territory',
    phoneNumberCountryCode: '246',
  },
  IQ: {
    isoAlpha2CountryCode: 'IQ',
    isoAlpha3CountryCode: 'IRQ',
    name: 'Iraq',
    phoneNumberCountryCode: '964',
  },
  IR: {
    isoAlpha2CountryCode: 'IR',
    isoAlpha3CountryCode: 'IRN',
    name: 'Iran',
    phoneNumberCountryCode: '98',
  },
  IS: {
    isoAlpha2CountryCode: 'IS',
    isoAlpha3CountryCode: 'ISL',
    name: 'Iceland',
    phoneNumberCountryCode: '354',
  },
  IT: {
    isoAlpha2CountryCode: 'IT',
    isoAlpha3CountryCode: 'ITA',
    name: 'Italy',
    phoneNumberCountryCode: '39',
  },
  JE: {
    isoAlpha2CountryCode: 'JE',
    isoAlpha3CountryCode: 'JEY',
    name: 'Jersey',
    phoneNumberCountryCode: '44',
  },
  JM: {
    isoAlpha2CountryCode: 'JM',
    isoAlpha3CountryCode: 'JAM',
    name: 'Jamaica',
    phoneNumberCountryCode: '1',
  },
  JO: {
    isoAlpha2CountryCode: 'JO',
    isoAlpha3CountryCode: 'JOR',
    name: 'Jordan',
    phoneNumberCountryCode: '962',
  },
  JP: {
    isoAlpha2CountryCode: 'JP',
    isoAlpha3CountryCode: 'JPN',
    name: 'Japan',
    phoneNumberCountryCode: '81',
  },
  KE: {
    isoAlpha2CountryCode: 'KE',
    isoAlpha3CountryCode: 'KEN',
    name: 'Kenya',
    phoneNumberCountryCode: '254',
  },
  KG: {
    isoAlpha2CountryCode: 'KG',
    isoAlpha3CountryCode: 'KGZ',
    name: 'Kyrgyzstan',
    phoneNumberCountryCode: '996',
  },
  KH: {
    isoAlpha2CountryCode: 'KH',
    isoAlpha3CountryCode: 'KHM',
    name: 'Cambodia',
    phoneNumberCountryCode: '855',
  },
  KI: {
    isoAlpha2CountryCode: 'KI',
    isoAlpha3CountryCode: 'KIR',
    name: 'Kiribati',
    phoneNumberCountryCode: '686',
  },
  KM: {
    isoAlpha2CountryCode: 'KM',
    isoAlpha3CountryCode: 'COM',
    name: 'Comoros',
    phoneNumberCountryCode: '269',
  },
  KN: {
    isoAlpha2CountryCode: 'KN',
    isoAlpha3CountryCode: 'KNA',
    name: 'Saint Kitts and Nevis',
    phoneNumberCountryCode: '1',
  },
  KP: {
    isoAlpha2CountryCode: 'KP',
    isoAlpha3CountryCode: 'PRK',
    name: 'North Korea',
    phoneNumberCountryCode: '850',
  },
  KR: {
    isoAlpha2CountryCode: 'KR',
    isoAlpha3CountryCode: 'KOR',
    name: 'South Korea',
    phoneNumberCountryCode: '82',
  },
  KW: {
    isoAlpha2CountryCode: 'KW',
    isoAlpha3CountryCode: 'KWT',
    name: 'Kuwait',
    phoneNumberCountryCode: '965',
  },
  KY: {
    isoAlpha2CountryCode: 'KY',
    isoAlpha3CountryCode: 'CYM',
    name: 'Cayman Islands',
    phoneNumberCountryCode: '1',
  },
  KZ: {
    isoAlpha2CountryCode: 'KZ',
    isoAlpha3CountryCode: 'KAZ',
    name: 'Kazakhstan',
    phoneNumberCountryCode: '7',
  },
  LA: {
    isoAlpha2CountryCode: 'LA',
    isoAlpha3CountryCode: 'LAO',
    name: 'Laos',
    phoneNumberCountryCode: '856',
  },
  LB: {
    isoAlpha2CountryCode: 'LB',
    isoAlpha3CountryCode: 'LBN',
    name: 'Lebanon',
    phoneNumberCountryCode: '961',
  },
  LC: {
    isoAlpha2CountryCode: 'LC',
    isoAlpha3CountryCode: 'LCA',
    name: 'Saint Lucia',
    phoneNumberCountryCode: '1',
  },
  LI: {
    isoAlpha2CountryCode: 'LI',
    isoAlpha3CountryCode: 'LIE',
    name: 'Liechtenstein',
    phoneNumberCountryCode: '423',
  },
  LK: {
    isoAlpha2CountryCode: 'LK',
    isoAlpha3CountryCode: 'LKA',
    name: 'Sri Lanka',
    phoneNumberCountryCode: '94',
  },
  LR: {
    isoAlpha2CountryCode: 'LR',
    isoAlpha3CountryCode: 'LBR',
    name: 'Liberia',
    phoneNumberCountryCode: '231',
  },
  LS: {
    isoAlpha2CountryCode: 'LS',
    isoAlpha3CountryCode: 'LSO',
    name: 'Lesotho',
    phoneNumberCountryCode: '266',
  },
  LT: {
    isoAlpha2CountryCode: 'LT',
    isoAlpha3CountryCode: 'LTU',
    name: 'Lithuania',
    phoneNumberCountryCode: '370',
  },
  LU: {
    isoAlpha2CountryCode: 'LU',
    isoAlpha3CountryCode: 'LUX',
    name: 'Luxembourg',
    phoneNumberCountryCode: '352',
  },
  LV: {
    isoAlpha2CountryCode: 'LV',
    isoAlpha3CountryCode: 'LVA',
    name: 'Latvia',
    phoneNumberCountryCode: '371',
  },
  LY: {
    isoAlpha2CountryCode: 'LY',
    isoAlpha3CountryCode: 'LBY',
    name: 'Libya',
    phoneNumberCountryCode: '218',
  },
  MA: {
    isoAlpha2CountryCode: 'MA',
    isoAlpha3CountryCode: 'MAR',
    name: 'Morocco',
    phoneNumberCountryCode: '212',
  },
  MC: {
    isoAlpha2CountryCode: 'MC',
    isoAlpha3CountryCode: 'MCO',
    name: 'Monaco',
    phoneNumberCountryCode: '377',
  },
  MD: {
    isoAlpha2CountryCode: 'MD',
    isoAlpha3CountryCode: 'MDA',
    name: 'Moldova',
    phoneNumberCountryCode: '373',
  },
  ME: {
    isoAlpha2CountryCode: 'ME',
    isoAlpha3CountryCode: 'MNE',
    name: 'Montenegro',
    phoneNumberCountryCode: '382',
  },
  MF: {
    isoAlpha2CountryCode: 'MF',
    isoAlpha3CountryCode: 'MAF',
    name: 'Saint Martin',
    phoneNumberCountryCode: '590',
  },
  MG: {
    isoAlpha2CountryCode: 'MG',
    isoAlpha3CountryCode: 'MDG',
    name: 'Madagascar',
    phoneNumberCountryCode: '261',
  },
  MH: {
    isoAlpha2CountryCode: 'MH',
    isoAlpha3CountryCode: 'MHL',
    name: 'Marshall Islands',
    phoneNumberCountryCode: '692',
  },
  MK: {
    isoAlpha2CountryCode: 'MK',
    isoAlpha3CountryCode: 'MKD',
    name: 'Macedonia',
    phoneNumberCountryCode: '389',
  },
  ML: {
    isoAlpha2CountryCode: 'ML',
    isoAlpha3CountryCode: 'MLI',
    name: 'Mali',
    phoneNumberCountryCode: '223',
  },
  MM: {
    isoAlpha2CountryCode: 'MM',
    isoAlpha3CountryCode: 'MMR',
    name: 'Myanmar',
    phoneNumberCountryCode: '95',
  },
  MN: {
    isoAlpha2CountryCode: 'MN',
    isoAlpha3CountryCode: 'MNG',
    name: 'Mongolia',
    phoneNumberCountryCode: '976',
  },
  MO: {
    isoAlpha2CountryCode: 'MO',
    isoAlpha3CountryCode: 'MAC',
    name: 'Macao',
    phoneNumberCountryCode: '853',
  },
  MP: {
    isoAlpha2CountryCode: 'MP',
    isoAlpha3CountryCode: 'MNP',
    name: 'Northern Mariana Islands',
    phoneNumberCountryCode: '1',
  },
  MQ: {
    isoAlpha2CountryCode: 'MQ',
    isoAlpha3CountryCode: 'MTQ',
    name: 'Martinique',
    phoneNumberCountryCode: '596',
  },
  MR: {
    isoAlpha2CountryCode: 'MR',
    isoAlpha3CountryCode: 'MRT',
    name: 'Mauritania',
    phoneNumberCountryCode: '222',
  },
  MS: {
    isoAlpha2CountryCode: 'MS',
    isoAlpha3CountryCode: 'MSR',
    name: 'Montserrat',
    phoneNumberCountryCode: '1',
  },
  MT: {
    isoAlpha2CountryCode: 'MT',
    isoAlpha3CountryCode: 'MLT',
    name: 'Malta',
    phoneNumberCountryCode: '356',
  },
  MU: {
    isoAlpha2CountryCode: 'MU',
    isoAlpha3CountryCode: 'MUS',
    name: 'Mauritius',
    phoneNumberCountryCode: '230',
  },
  MV: {
    isoAlpha2CountryCode: 'MV',
    isoAlpha3CountryCode: 'MDV',
    name: 'Maldives',
    phoneNumberCountryCode: '960',
  },
  MW: {
    isoAlpha2CountryCode: 'MW',
    isoAlpha3CountryCode: 'MWI',
    name: 'Malawi',
    phoneNumberCountryCode: '265',
  },
  MX: {
    isoAlpha2CountryCode: 'MX',
    isoAlpha3CountryCode: 'MEX',
    name: 'Mexico',
    phoneNumberCountryCode: '52',
  },
  MY: {
    isoAlpha2CountryCode: 'MY',
    isoAlpha3CountryCode: 'MYS',
    name: 'Malaysia',
    phoneNumberCountryCode: '60',
  },
  MZ: {
    isoAlpha2CountryCode: 'MZ',
    isoAlpha3CountryCode: 'MOZ',
    name: 'Mozambique',
    phoneNumberCountryCode: '258',
  },
  NA: {
    isoAlpha2CountryCode: 'NA',
    isoAlpha3CountryCode: 'NAME',
    name: 'Namibia',
    phoneNumberCountryCode: '264',
  },
  NC: {
    isoAlpha2CountryCode: 'NC',
    isoAlpha3CountryCode: 'NCL',
    name: 'New Caledonia',
    phoneNumberCountryCode: '687',
  },
  NE: {
    isoAlpha2CountryCode: 'NE',
    isoAlpha3CountryCode: 'NER',
    name: 'Niger',
    phoneNumberCountryCode: '227',
  },
  NF: {
    isoAlpha2CountryCode: 'NF',
    isoAlpha3CountryCode: 'NFK',
    name: 'Norfolk Island',
    phoneNumberCountryCode: '672',
  },
  NG: {
    isoAlpha2CountryCode: 'NG',
    isoAlpha3CountryCode: 'NGA',
    name: 'Nigeria',
    phoneNumberCountryCode: '234',
  },
  NI: {
    isoAlpha2CountryCode: 'NI',
    isoAlpha3CountryCode: 'NIC',
    name: 'Nicaragua',
    phoneNumberCountryCode: '505',
  },
  NL: {
    isoAlpha2CountryCode: 'NL',
    isoAlpha3CountryCode: 'NLD',
    name: 'Netherlands',
    phoneNumberCountryCode: '31',
  },
  NO: {
    isoAlpha2CountryCode: 'NO',
    isoAlpha3CountryCode: 'NOR',
    name: 'Norway',
    phoneNumberCountryCode: '47',
  },
  NP: {
    isoAlpha2CountryCode: 'NP',
    isoAlpha3CountryCode: 'NPL',
    name: 'Nepal',
    phoneNumberCountryCode: '977',
  },
  NR: {
    isoAlpha2CountryCode: 'NR',
    isoAlpha3CountryCode: 'NRU',
    name: 'Nauru',
    phoneNumberCountryCode: '674',
  },
  NU: {
    isoAlpha2CountryCode: 'NU',
    isoAlpha3CountryCode: 'NIU',
    name: 'Niue',
    phoneNumberCountryCode: '683',
  },
  NZ: {
    isoAlpha2CountryCode: 'NZ',
    isoAlpha3CountryCode: 'NZL',
    name: 'New Zealand',
    phoneNumberCountryCode: '64',
  },
  OM: {
    isoAlpha2CountryCode: 'OM',
    isoAlpha3CountryCode: 'OMN',
    name: 'Oman',
    phoneNumberCountryCode: '968',
  },
  PA: {
    isoAlpha2CountryCode: 'PA',
    isoAlpha3CountryCode: 'PAN',
    name: 'Panama',
    phoneNumberCountryCode: '507',
  },
  PE: {
    isoAlpha2CountryCode: 'PE',
    isoAlpha3CountryCode: 'PER',
    name: 'Peru',
    phoneNumberCountryCode: '51',
  },
  PF: {
    isoAlpha2CountryCode: 'PF',
    isoAlpha3CountryCode: 'PYF',
    name: 'French Polynesia',
    phoneNumberCountryCode: '689',
  },
  PG: {
    isoAlpha2CountryCode: 'PG',
    isoAlpha3CountryCode: 'PNG',
    name: 'Papua New Guinea',
    phoneNumberCountryCode: '675',
  },
  PH: {
    isoAlpha2CountryCode: 'PH',
    isoAlpha3CountryCode: 'PHL',
    name: 'Philippines',
    phoneNumberCountryCode: '63',
  },
  PK: {
    isoAlpha2CountryCode: 'PK',
    isoAlpha3CountryCode: 'PAK',
    name: 'Pakistan',
    phoneNumberCountryCode: '92',
  },
  PL: {
    isoAlpha2CountryCode: 'PL',
    isoAlpha3CountryCode: 'POL',
    name: 'Poland',
    phoneNumberCountryCode: '48',
  },
  PM: {
    isoAlpha2CountryCode: 'PM',
    isoAlpha3CountryCode: 'SPM',
    name: 'Saint Pierre and Miquelon',
    phoneNumberCountryCode: '508',
  },
  PN: {
    isoAlpha2CountryCode: 'PN',
    isoAlpha3CountryCode: 'PCN',
    name: 'Pitcairn',
    phoneNumberCountryCode: '64',
  },
  PR: {
    isoAlpha2CountryCode: 'PR',
    isoAlpha3CountryCode: 'PRI',
    name: 'Puerto Rico',
    phoneNumberCountryCode: '1',
  },
  PS: {
    isoAlpha2CountryCode: 'PS',
    isoAlpha3CountryCode: 'PSE',
    name: 'Palestine',
    phoneNumberCountryCode: '970',
  },
  PT: {
    isoAlpha2CountryCode: 'PT',
    isoAlpha3CountryCode: 'PRT',
    name: 'Portugal',
    phoneNumberCountryCode: '351',
  },
  PW: {
    isoAlpha2CountryCode: 'PW',
    isoAlpha3CountryCode: 'PLW',
    name: 'Palau',
    phoneNumberCountryCode: '680',
  },
  PY: {
    isoAlpha2CountryCode: 'PY',
    isoAlpha3CountryCode: 'PRY',
    name: 'Paraguay',
    phoneNumberCountryCode: '595',
  },
  QA: {
    isoAlpha2CountryCode: 'QA',
    isoAlpha3CountryCode: 'QAT',
    name: 'Qatar',
    phoneNumberCountryCode: '974',
  },
  RE: {
    isoAlpha2CountryCode: 'RE',
    isoAlpha3CountryCode: 'REU',
    name: 'Reunion',
    phoneNumberCountryCode: '262',
  },
  RO: {
    isoAlpha2CountryCode: 'RO',
    isoAlpha3CountryCode: 'ROU',
    name: 'Romania',
    phoneNumberCountryCode: '40',
  },
  RS: {
    isoAlpha2CountryCode: 'RS',
    isoAlpha3CountryCode: 'SRB',
    name: 'Serbia',
    phoneNumberCountryCode: '381',
  },
  RU: {
    isoAlpha2CountryCode: 'RU',
    isoAlpha3CountryCode: 'RUS',
    name: 'Russia',
    phoneNumberCountryCode: '7',
  },
  RW: {
    isoAlpha2CountryCode: 'RW',
    isoAlpha3CountryCode: 'RWA',
    name: 'Rwanda',
    phoneNumberCountryCode: '250',
  },
  SA: {
    isoAlpha2CountryCode: 'SA',
    isoAlpha3CountryCode: 'SAU',
    name: 'Saudi Arabia',
    phoneNumberCountryCode: '966',
  },
  SB: {
    isoAlpha2CountryCode: 'SB',
    isoAlpha3CountryCode: 'SLB',
    name: 'Solomon Islands',
    phoneNumberCountryCode: '677',
  },
  SC: {
    isoAlpha2CountryCode: 'SC',
    isoAlpha3CountryCode: 'SYC',
    name: 'Seychelles',
    phoneNumberCountryCode: '248',
  },
  SD: {
    isoAlpha2CountryCode: 'SD',
    isoAlpha3CountryCode: 'SDN',
    name: 'Sudan',
    phoneNumberCountryCode: '249',
  },
  SE: {
    isoAlpha2CountryCode: 'SE',
    isoAlpha3CountryCode: 'SWE',
    name: 'Sweden',
    phoneNumberCountryCode: '46',
  },
  SG: {
    isoAlpha2CountryCode: 'SG',
    isoAlpha3CountryCode: 'SGP',
    name: 'Singapore',
    phoneNumberCountryCode: '65',
  },
  SH: {
    isoAlpha2CountryCode: 'SH',
    isoAlpha3CountryCode: 'SHN',
    name: 'Saint Helena',
    phoneNumberCountryCode: '290',
  },
  SI: {
    isoAlpha2CountryCode: 'SI',
    isoAlpha3CountryCode: 'SVN',
    name: 'Slovenia',
    phoneNumberCountryCode: '386',
  },
  SJ: {
    isoAlpha2CountryCode: 'SJ',
    isoAlpha3CountryCode: 'SJM',
    name: 'Svalbard and Jan Mayen',
    phoneNumberCountryCode: '47',
  },
  SK: {
    isoAlpha2CountryCode: 'SK',
    isoAlpha3CountryCode: 'SVK',
    name: 'Slovakia',
    phoneNumberCountryCode: '421',
  },
  SL: {
    isoAlpha2CountryCode: 'SL',
    isoAlpha3CountryCode: 'SLE',
    name: 'Sierra Leone',
    phoneNumberCountryCode: '232',
  },
  SM: {
    isoAlpha2CountryCode: 'SM',
    isoAlpha3CountryCode: 'SMR',
    name: 'San Marino',
    phoneNumberCountryCode: '378',
  },
  SN: {
    isoAlpha2CountryCode: 'SN',
    isoAlpha3CountryCode: 'SEN',
    name: 'Senegal',
    phoneNumberCountryCode: '221',
  },
  SO: {
    isoAlpha2CountryCode: 'SO',
    isoAlpha3CountryCode: 'SOM',
    name: 'Somalia',
    phoneNumberCountryCode: '252',
  },
  SR: {
    isoAlpha2CountryCode: 'SR',
    isoAlpha3CountryCode: 'SUR',
    name: 'Suriname',
    phoneNumberCountryCode: '597',
  },
  SS: {
    isoAlpha2CountryCode: 'SS',
    isoAlpha3CountryCode: 'SSD',
    name: 'South Sudan',
    phoneNumberCountryCode: '211',
  },
  ST: {
    isoAlpha2CountryCode: 'ST',
    isoAlpha3CountryCode: 'STP',
    name: 'Sao Tome and Principe',
    phoneNumberCountryCode: '239',
  },
  SV: {
    isoAlpha2CountryCode: 'SV',
    isoAlpha3CountryCode: 'SLV',
    name: 'El Salvador',
    phoneNumberCountryCode: '503',
  },
  SX: {
    isoAlpha2CountryCode: 'SX',
    isoAlpha3CountryCode: 'SXM',
    name: 'Sint Maarten',
    phoneNumberCountryCode: '1',
  },
  SY: {
    isoAlpha2CountryCode: 'SY',
    isoAlpha3CountryCode: 'SYR',
    name: 'Syria',
    phoneNumberCountryCode: '963',
  },
  SZ: {
    isoAlpha2CountryCode: 'SZ',
    isoAlpha3CountryCode: 'SWZ',
    name: 'Swaziland',
    phoneNumberCountryCode: '268',
  },
  TC: {
    isoAlpha2CountryCode: 'TC',
    isoAlpha3CountryCode: 'TCA',
    name: 'Turks and Caicos Islands',
    phoneNumberCountryCode: '1',
  },
  TD: {
    isoAlpha2CountryCode: 'TD',
    isoAlpha3CountryCode: 'TCD',
    name: 'Chad',
    phoneNumberCountryCode: '235',
  },
  TF: {
    isoAlpha2CountryCode: 'TF',
    isoAlpha3CountryCode: 'ATF',
    name: 'French Southern Territories',
    phoneNumberCountryCode: '262',
  },
  TG: {
    isoAlpha2CountryCode: 'TG',
    isoAlpha3CountryCode: 'TGO',
    name: 'Togo',
    phoneNumberCountryCode: '228',
  },
  TH: {
    isoAlpha2CountryCode: 'TH',
    isoAlpha3CountryCode: 'THA',
    name: 'Thailand',
    phoneNumberCountryCode: '66',
  },
  TJ: {
    isoAlpha2CountryCode: 'TJ',
    isoAlpha3CountryCode: 'TJK',
    name: 'Tajikistan',
    phoneNumberCountryCode: '992',
  },
  TK: {
    isoAlpha2CountryCode: 'TK',
    isoAlpha3CountryCode: 'TKL',
    name: 'Tokelau',
    phoneNumberCountryCode: '690',
  },
  TL: {
    isoAlpha2CountryCode: 'TL',
    isoAlpha3CountryCode: 'TLS',
    name: 'East Timor',
    phoneNumberCountryCode: '670',
  },
  TM: {
    isoAlpha2CountryCode: 'TM',
    isoAlpha3CountryCode: 'TKM',
    name: 'Turkmenistan',
    phoneNumberCountryCode: '993',
  },
  TN: {
    isoAlpha2CountryCode: 'TN',
    isoAlpha3CountryCode: 'TUN',
    name: 'Tunisia',
    phoneNumberCountryCode: '216',
  },
  TO: {
    isoAlpha2CountryCode: 'TO',
    isoAlpha3CountryCode: 'TON',
    name: 'Tonga',
    phoneNumberCountryCode: '676',
  },
  TR: {
    isoAlpha2CountryCode: 'TR',
    isoAlpha3CountryCode: 'TUR',
    name: 'Turkey',
    phoneNumberCountryCode: '90',
  },
  TT: {
    isoAlpha2CountryCode: 'TT',
    isoAlpha3CountryCode: 'TTO',
    name: 'Trinidad and Tobago',
    phoneNumberCountryCode: '1',
  },
  TV: {
    isoAlpha2CountryCode: 'TV',
    isoAlpha3CountryCode: 'TUV',
    name: 'Tuvalu',
    phoneNumberCountryCode: '688',
  },
  TW: {
    isoAlpha2CountryCode: 'TW',
    isoAlpha3CountryCode: 'TWN',
    name: 'Taiwan',
    phoneNumberCountryCode: '886',
  },
  TZ: {
    isoAlpha2CountryCode: 'TZ',
    isoAlpha3CountryCode: 'TZA',
    name: 'Tanzania',
    phoneNumberCountryCode: '255',
  },
  UA: {
    isoAlpha2CountryCode: 'UA',
    isoAlpha3CountryCode: 'UKR',
    name: 'Ukraine',
    phoneNumberCountryCode: '380',
  },
  UG: {
    isoAlpha2CountryCode: 'UG',
    isoAlpha3CountryCode: 'UGA',
    name: 'Uganda',
    phoneNumberCountryCode: '256',
  },
  UM: {
    isoAlpha2CountryCode: 'UM',
    isoAlpha3CountryCode: 'UMI',
    name: 'United States Minor Outlying Islands',
    phoneNumberCountryCode: '1',
  },
  US: {
    isoAlpha2CountryCode: 'US',
    isoAlpha3CountryCode: 'USA',
    name: 'United States',
    phoneNumberCountryCode: '1',
  },
  UY: {
    isoAlpha2CountryCode: 'UY',
    isoAlpha3CountryCode: 'URY',
    name: 'Uruguay',
    phoneNumberCountryCode: '598',
  },
  UZ: {
    isoAlpha2CountryCode: 'UZ',
    isoAlpha3CountryCode: 'UZB',
    name: 'Uzbekistan',
    phoneNumberCountryCode: '998',
  },
  VA: {
    isoAlpha2CountryCode: 'VA',
    isoAlpha3CountryCode: 'VAT',
    name: 'Vatican',
    phoneNumberCountryCode: '379',
  },
  VC: {
    isoAlpha2CountryCode: 'VC',
    isoAlpha3CountryCode: 'VCT',
    name: 'Saint Vincent and the Grenadines',
    phoneNumberCountryCode: '1',
  },
  VE: {
    isoAlpha2CountryCode: 'VE',
    isoAlpha3CountryCode: 'VEN',
    name: 'Venezuela',
    phoneNumberCountryCode: '58',
  },
  VG: {
    isoAlpha2CountryCode: 'VG',
    isoAlpha3CountryCode: 'VGB',
    name: 'British Virgin Islands',
    phoneNumberCountryCode: '1',
  },
  VI: {
    isoAlpha2CountryCode: 'VI',
    isoAlpha3CountryCode: 'VIR',
    name: 'U.S. Virgin Islands',
    phoneNumberCountryCode: '1',
  },
  VN: {
    isoAlpha2CountryCode: 'VN',
    isoAlpha3CountryCode: 'VNM',
    name: 'Vietnam',
    phoneNumberCountryCode: '84',
  },
  VU: {
    isoAlpha2CountryCode: 'VU',
    isoAlpha3CountryCode: 'VUT',
    name: 'Vanuatu',
    phoneNumberCountryCode: '678',
  },
  WF: {
    isoAlpha2CountryCode: 'WF',
    isoAlpha3CountryCode: 'WLF',
    name: 'Wallis and Futuna',
    phoneNumberCountryCode: '681',
  },
  WS: {
    isoAlpha2CountryCode: 'WS',
    isoAlpha3CountryCode: 'WSM',
    name: 'Samoa',
    phoneNumberCountryCode: '685',
  },
  XK: {
    isoAlpha2CountryCode: 'XK',
    isoAlpha3CountryCode: 'XKX',
    name: 'Kosovo',
    phoneNumberCountryCode: '383',
  },
  YE: {
    isoAlpha2CountryCode: 'YE',
    isoAlpha3CountryCode: 'YEM',
    name: 'Yemen',
    phoneNumberCountryCode: '967',
  },
  YT: {
    isoAlpha2CountryCode: 'YT',
    isoAlpha3CountryCode: 'MYT',
    name: 'Mayotte',
    phoneNumberCountryCode: '262',
  },
  ZA: {
    isoAlpha2CountryCode: 'ZA',
    isoAlpha3CountryCode: 'ZAF',
    name: 'South Africa',
    phoneNumberCountryCode: '27',
  },
  ZM: {
    isoAlpha2CountryCode: 'ZM',
    isoAlpha3CountryCode: 'ZMB',
    name: 'Zambia',
    phoneNumberCountryCode: '260',
  },
  ZW: {
    isoAlpha2CountryCode: 'ZW',
    isoAlpha3CountryCode: 'ZWE',
    name: 'Zimbabwe',
    phoneNumberCountryCode: '263',
  },
} as const

export type CountryCode = keyof typeof countries
